import React, { useState }  from 'react';
import Apiboxd from '../assets/images/New_Jul_2025/Apibox.svg';
import { MdOutlineFileDownload } from "react-icons/md";
import { FaEye } from "react-icons/fa";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";


function Apibox() {
  const handleDownload = () => {
    window.open('https://drive.google.com/file/d/1NQbeHt69j6kY0avbkoVprLzMtT8sfqvJ/view?usp=sharing', '_blank');
function StripeModal({ open, onClose, clientSecret }) {
  const stripe = useStripe();
  const elements = useElements();
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

}}

  return (
    <>
       <div className="flex flex-col md:flex-row h-[80vh] justify-between items-center bg-gray-50 p-10 rounded-lg shadow-md">
      <div className="mb-8 md:mb-0">
        <h2 className="text-[3.1rem] font-bold text-[#0B4445] mb-4">API BOX</h2>
        <h1 className="text-[2.1rem] md:text-4xl font-semibold mb-4">
          Manage API Access &amp; Documentation
        </h1>
        <div className="flex gap-4">
          <button className="flex items-center px-4 py-2 bg-white border border-gray-300 rounded hover:bg-gray-100"
                        onClick={handleDownload}
>

            Download API
            <MdOutlineFileDownload size={30} />
            
          </button>
           {/* <button 
           className="flex items-center px-4 py-2 bg-white border border-gray-300 rounded hover:bg-gray-100"
              onClick={handleDownload}
            >
               API Document <FaEye size={25} className="ml-2" />
            </button> */}
   
        </div>
      </div>
      <div>
        <img
          src={Apiboxd}
          alt="API Illustration"
          className="w-[330px] md:w-[630px]"
        />
      </div>
    </div>
    </>

    )
  
}

export default Apibox;